import AdminList from "./AdminList";

export default function Users() {
  return <AdminList type="users" />;
}
